import styled from 'styled-components';

import { colors } from '@soluto-private/mx-asurion-ui-react';

const Container = styled.header`
  align-items: center;
  justify-content: space-between;
  display: flex;
  width: 100%;
  padding: 0 var(--pageLayoutPadding);
  height: var(--headerHeight);
  border-bottom: 1px solid ${colors.neutralBright};
  gap: 8px;
`;

const LogoContainer = styled.button`
  display: flex;
  cursor: pointer;
  flex-shrink: 0;
`;

export const Header = () => {
  return (
    <Container id="header-portal-id">
      <LogoContainer
        data-testid="repairs-header-logo"
        onClick={() =>
          window.open('https://www.asurion.com/repairs/tech', '_self')
        }
      >
        <img
          alt="u break i fix by asurion logo"
          data-svg-file-name="ubreakifix-asurion-logo.svg"
          data-testid="repairs-header-logos"
          height="48px"
          src="https://assets.asurion-ui.my.asurion53.com/images/logos/ubreakifix-asurion-logo.svg"
        />
      </LogoContainer>
    </Container>
  );
};
